
import OrderLocationMap from '@/components/common/OrderLocationMap.vue'
import PhoneCallButton from '@/components/common/PhoneCallButton.vue'
import BaseActionButton from '@/components/common/BaseActionButton.vue'

export default {
  name: 'AdminAssignCourier',
  components: { OrderLocationMap, PhoneCallButton, BaseActionButton },
  data () {
    return {
      orderId: null,
      order: null,
      couriers: [],
      loading: true,
      statusFilter: 'all',
      selectedCourier: null,
      showReassignConfirm: false,
      showAssignConfirm: false,
      assigning: false
    }
  },
  computed: {
    filteredCouriers () {
      let list = this.couriers
      if (this.statusFilter !== 'all') {
        list = list.filter(c => c.courier_status === this.statusFilter)
      }
      // 按状态排序：在线 > 忙碌 > 离线 > 业务员(无 courier_status)
      const statusOrder = { online: 0, busy: 1, offline: 2 }
      const getOrder = c => c.courier_status ? (statusOrder[c.courier_status] ?? 3) : 3
      return list.sort((a, b) => getOrder(a) - getOrder(b))
    },
    selectedCourierInfo () {
      return this.couriers.find(c => c.id === this.selectedCourier)
    }
  },
  created () {
    this.orderId = this.$route.params.id
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        // 并行获取订单详情和配送员列表
        const [orderRes, courierRes] = await Promise.all([
          this.axios.get(`/admin-mobile/orders/${this.orderId}`),
          this.axios.get('/admin-mobile/couriers')
        ])
        this.order = orderRes.data.data
        this.couriers = courierRes.data.data || []

        // 如果已有配送员，默认选中
        if (this.order?.assigned_courier_id) {
          this.selectedCourier = this.order.assigned_courier_id
        }
      } catch (err) {
        console.error('加载数据失败:', err)
        this.$toast?.fail?.('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    selectCourier (courier) {
      if (courier.id === this.order?.assigned_courier_id) {
        return // 不能选择当前配送员
      }
      this.selectedCourier = courier.id
    },
    confirmAssign () {
      if (!this.selectedCourier) return
      this.showAssignConfirm = true
    },
    async doAssign () {
      this.assigning = true
      try {
        const url = this.order?.assigned_courier_id
          ? `/admin-mobile/orders/${this.orderId}/reassign`
          : `/admin-mobile/orders/${this.orderId}/assign`

        await this.axios.post(url, {
          courier_id: this.selectedCourier
        })

        this.$toast?.success?.('指派成功')
        this.$router.back()
      } catch (err) {
        console.error('指派失败:', err)
        this.$toast?.fail?.('指派失败，请重试')
      } finally {
        this.assigning = false
        this.showAssignConfirm = false
      }
    },
    doReassign () {
      this.showReassignConfirm = false
      // 清空选择，让用户重新选择
      this.selectedCourier = null
    },
    getAvatarColor (status) {
      const colors = {
        online: '#4caf50',
        busy: '#ff9800',
        offline: '#999'
      }
      return colors[status] || '#999'
    },
    statusText (status) {
      const map = {
        online: '在线',
        busy: '忙碌',
        offline: '离线',
        pending: '待审核',
        confirmed: '已确认',
        picking: '配货中',
        packed: '已配货',
        inspecting: '验货中',
        inspection_pending: '待验货',
        delivery_pending: '待指派',
        delivering: '配送中',
        delivered: '已送达',
        completed: '已完成',
        cancelled: '已取消'
      }
      return map[status] || status
    },
    formatTime (timeStr) {
      if (!timeStr) return '-'
      const date = new Date(timeStr)
      return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
    }
  }
}
